import { render, staticRenderFns } from "./StaffName.vue?vue&type=template&id=5c5485af&scoped=true&"
import script from "./StaffName.vue?vue&type=script&lang=js&"
export * from "./StaffName.vue?vue&type=script&lang=js&"
import style0 from "./StaffName.vue?vue&type=style&index=0&id=5c5485af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5485af",
  null
  
)

export default component.exports